import { FirmApi } from "@/api";
import i18n from "@/i18n";
import { showSuccessSnackbar } from "@/utilities/snackbar";

export async function getAll() {
  const { data } = await FirmApi.getAll();
  return data;
}

export async function get(id) {
  const { data } = await FirmApi.get(id);
  return data;
}

export async function create(data) {
  const { status, data: response } = await FirmApi.create(data);
  showSuccessSnackbar(status, `${i18n.t("firm-created-correctly")}`);
  return response;
}

export async function update(firmId, data) {
  const { data: response } = await FirmApi.update(firmId, data);
  return response;
}

export async function getSubscription(firmId) {
  const { data: response } = await FirmApi.getSubscription(firmId);
  return response;
}

export async function updateSubscription(firmId, data) {
  const { data: response } = await FirmApi.updateSubscription(firmId, data);
  return response;
}

export async function toggle(firmId) {
  const { data: response } = await FirmApi.toggle(firmId);
  return response;
}

export async function getEnterprises(firmId) {
  const { data } = await FirmApi.getEnterprises(firmId);
  return data;
}

export async function recalculateUsageQuota(firmId) {
  const { data } = await FirmApi.recalculateUsageQuota(firmId);
  return data;
}
